import { awaitRequests, promise } from '../../../helpers';
import { saveExamSubmissionFiles } from '.';
import { upsertGradeForSubmission } from '../grades';

const addExamSubmission = ({ data, uploadList }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('examSubmissions')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = item => {
            const reqs = [];

            // upload files
            reqs.push(dispatch(saveExamSubmissionFiles(item, uploadList)));
            reqs.push(dispatch(upsertGradeForSubmission(item, 'exam')));

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addExamSubmission;
